import AuthService from "../services/security/auth.service"
import informationService from '../services/system';
import setAccountId from "./setAccountId";

const setTrxLine3 = (item, field, previousValue, listGroups, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, index, deleteGroup, searchFieldSource, setValueSearchSource, mode, arrayAmout, arrayQty) => {
    try {
        console.log('arrayAmout-> ' + JSON.stringify(arrayAmout))
        const user = AuthService.getCurrentUser();
        let requestArrayTariff = [];

        let validate = false;
        if (item) {
            let idField = item.id;
            let currentValue = field[idField];
            if (currentValue !== previousValue[idField]) {
                validate = true;
            }
        }

        if ((validate === true) || (item === null && previousValue === null)) {
            //cabecera

            let entityPropertyId = null;
            let trxPropId = null;
            let daysToDue = 0;
            let rateOverride = null;
            data.crud.boxes.forEach((itemBoxes) => {
                itemBoxes.fields.forEach((itemFields) => {
                    let idfield = itemFields.id;
                    if (field[idfield]) {
                        switch (itemFields.idFieldTable) {
                            case 'daysToDue':
                                daysToDue = field[idfield] ? field[idfield] : 0;
                                break;
                            case 'entityPropertyId':
                                entityPropertyId = field[idfield].id;
                                break;
                            case 'trxPropId':
                                trxPropId = field[idfield].id;
                                break;
                            case 'rateOverride':
                                if (field[idfield]) {
                                    rateOverride = Number(field[idfield].toString().replace(/,/g, '.'));
                                }
                                break;
                            default:
                                break;
                        }
                    }
                })
            });

            //linea
            for (let t = 0; t < listGroups.length; t++) {
                const nameGroup = listGroups[t];
                if (group[nameGroup]) {

                    let sign = 1;
                    let isGuarantee = 0;
                    console.log('nameGroup-> ' + JSON.stringify(nameGroup))
                    console.log('group[nameGroup].length-> ' + JSON.stringify(group[nameGroup].length))
                    for (let y = 0; y < group[nameGroup].length; y++) {

                        for (let i = 0; i < group[nameGroup][0].fields.length; i++) {
                            if (group[nameGroup][0].fields[i].idFieldTable === 'sign') {
                                sign = field[group[nameGroup][0].fields[i].id];
                            }
                            if (group[nameGroup][0].fields[i].idFieldTable === 'isGuarantee') {
                                isGuarantee = field[group[nameGroup][0].fields[i].id];
                            }
                        }
                        console.log('isGuarantee-> ' + JSON.stringify(isGuarantee))
                        if (Number(isGuarantee) === 0) {
                            console.log('requestArrayTariff.length-> ' + JSON.stringify(requestArrayTariff.length))
                            if (requestArrayTariff.length === 0) {
                                let amount = 0;
                                let qty = 0;
                                let itemPropertyId;
                                let fxRate = 1;
                                let currencyId = null;
                                for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                    switch (group[nameGroup][y].fields[i].idFieldTable) {
                                        case 'amount':
                                            console.log('amount-> ' + amount)
                                            if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                }
                                                console.log('view-> ' + view)
                                                console.log('valor importe-> ' + JSON.stringify(field[group[nameGroup][y].fields[i].id]))
                                                if (view && field[group[nameGroup][y].fields[i].id]) {
                                                    let amountObject = Number(field[group[nameGroup][y].fields[i].id].toString().replace(/,/g, '.'));
                                                    for (let h = 0; h < arrayAmout.length; h++) {
                                                        if (y === arrayAmout[h].index) {
                                                            amountObject = arrayAmout[h].amount;
                                                            console.log('amountObject-> ' + amountObject)
                                                        }
                                                    }
                                                    amount = Number(amount) + Number(amountObject);
                                                } else {
                                                    if (view) {
                                                        let amountObject = 0;
                                                        for (let h = 0; h < arrayAmout.length; h++) {
                                                            if (y === arrayAmout[h].index) {
                                                                amountObject = arrayAmout[h].amount;
                                                                console.log('amountObject-> ' + amountObject)
                                                            }
                                                        }
                                                        amount = Number(amount) + Number(amountObject);
                                                    }
                                                }
                                            }
                                            break;
                                        case 'qty':
                                            if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                }

                                                if (view && field[group[nameGroup][y].fields[i].id]) {
                                                    let qtyObject = Number(field[group[nameGroup][y].fields[i].id].toString().replace(/,/g, '.'));
                                                    for (let h = 0; h < arrayQty.length; h++) {
                                                        if (y === arrayQty[h].index) {
                                                            qtyObject = arrayQty[h].qty;
                                                        }
                                                    }
                                                    qty = Number(qty) + Number(qtyObject);
                                                }
                                            }
                                            break;
                                        case 'itemPropertyId':
                                            if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup][y].fields[i].id])
                                                        itemPropertyId = field[group[nameGroup][y].fields[i].id].id;
                                            }
                                            break;
                                        case 'fxRate':
                                            if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    fxRate = field[group[nameGroup][y].fields[i].id];
                                            }
                                            break;
                                        case 'currencyId':
                                            if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup][y].fields[i].id])
                                                        currencyId = field[group[nameGroup][y].fields[i].id].id;
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                console.log('fxRate-> ' + fxRate)
                                console.log('currencyId-> ' + currencyId)
                                console.log('entityPropertyId-> ' + entityPropertyId)
                                console.log('trxPropId-> ' + trxPropId)
                                console.log('itemPropertyId-> ' + itemPropertyId)
                                console.log('amount-> ' + amount)
                                console.log('qty-> ' + qty)

                                if (fxRate && currencyId && entityPropertyId && trxPropId && itemPropertyId && (amount || qty)) {
                                    requestArrayTariff.push({
                                        daysToDue: Number(daysToDue),
                                        fxRate: Number(fxRate.toString().replace(/,/g, '.')),
                                        currencyId: Number(currencyId),
                                        entityPropertyId: Number(entityPropertyId),
                                        trxPropId: Number(trxPropId),
                                        rateOverride: rateOverride,
                                        amount: Number(amount.toString().replace(/,/g, '.')),
                                        qty: Number(qty.toString().replace(/,/g, '.')),
                                        itemPropertyId: Number(itemPropertyId)
                                    })
                                }

                            } else {
                                let existe = false;
                                for (let b = 0; b < requestArrayTariff.length; b++) {
                                    let valueItemPropertyId;
                                    let valueCurrencyId;
                                    let valueFxRateId = 1;
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        switch (group[nameGroup][y].fields[i].idFieldTable) {
                                            case 'itemPropertyId':
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup][y].fields[i].id])
                                                            valueItemPropertyId = field[group[nameGroup][y].fields[i].id].id
                                                }
                                                break;
                                            case 'fxRate':
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        valueFxRateId = field[group[nameGroup][y].fields[i].id].replace(/,/g, '.');
                                                }
                                                break;
                                            case 'currencyId':
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup][y].fields[i].id])
                                                            valueCurrencyId = field[group[nameGroup][y].fields[i].id].id
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                    console.log('valueItemPropertyId-> ' + valueItemPropertyId)
                                    console.log('valueFxRateId-> ' + valueFxRateId)
                                    console.log('valueCurrencyId-> ' + valueCurrencyId)
                                    console.log('requestArrayTariff test-> ' + JSON.stringify(requestArrayTariff))
                                    if (Number(requestArrayTariff[b].itemPropertyId) === Number(valueItemPropertyId) &&
                                        Number(requestArrayTariff[b].fxRate) === Number(valueFxRateId) &&
                                        Number(requestArrayTariff[b].currencyId) === Number(valueCurrencyId)) {
                                        console.log('ingresa-> ' + valueItemPropertyId)
                                        for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                            let idField = group[nameGroup][y].fields[i].id;
                                            switch (group[nameGroup][y].fields[i].idFieldTable) {
                                                case 'amount':
                                                    if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                        let view = true;
                                                        if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                            view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                        }
                                                        if (view && field[idField]) {
                                                            let importe = Number(field[idField].toString().replace(/,/g, '.'));
                                                            for (let h = 0; h < arrayAmout.length; h++) {
                                                                if (y === arrayAmout[h].index) {
                                                                    importe = arrayAmout[h].amount;
                                                                }
                                                            }
                                                            let importeAnterior = Number(requestArrayTariff[b].amount);
                                                            requestArrayTariff[b].amount = Number(importeAnterior) + Number(importe);
                                                        }
                                                    }
                                                    break;
                                                case 'qty':
                                                    if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                        let view = true;
                                                        if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                            view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                        }
                                                        if (view && field[idField]) {
                                                            let cantidad = Number(field[idField].toString().replace(/,/g, '.'));
                                                            for (let h = 0; h < arrayQty.length; h++) {
                                                                if (y === arrayQty[h].index) {
                                                                    cantidad = arrayQty[h].qty;
                                                                }
                                                            }

                                                            let cantidadAnterior = Number(requestArrayTariff[b].qty)
                                                            requestArrayTariff[b].qty = Number(cantidadAnterior) + Number(cantidad);
                                                        }
                                                    }
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                        existe = true;
                                    }
                                }

                                console.log('existe-> ' + existe)
                                if (existe === false) {

                                    let amount;
                                    let qty;
                                    let itemPropertyId;
                                    let fxRate = 1;
                                    let currencyId = null;
                                    for (let i = 0; i < group[nameGroup][y].fields.length; i++) {
                                        switch (group[nameGroup][y].fields[i].idFieldTable) {
                                            case 'amount':
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view && field[group[nameGroup][y].fields[i].id]) {
                                                        let amountObject = Number(field[group[nameGroup][y].fields[i].id].toString().replace(/,/g, '.'));
                                                        for (let h = 0; h < arrayAmout.length; h++) {
                                                            if (y === arrayAmout[h].index) {
                                                                amountObject = arrayAmout[h].amount;
                                                            }
                                                        }
                                                        amount = Number(amount) + Number(amountObject);

                                                    }
                                                }
                                                break;
                                            case 'qty':
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view && field[group[nameGroup][y].fields[i].id]) {
                                                        let qtyObject = Number(field[group[nameGroup][y].fields[i].id].toString().replace(/,/g, '.'));
                                                        for (let h = 0; h < arrayQty.length; h++) {
                                                            if (y === arrayQty[h].index) {
                                                                qtyObject = arrayQty[h].qty;
                                                            }
                                                        }
                                                        qty = Number(qty) + Number(qtyObject);

                                                    }
                                                }
                                                break;
                                            case 'itemPropertyId':
                                                console.log('id itemPropertyId-> ' + JSON.stringify(group[nameGroup][y].fields[i].id))
                                                console.log('field itemPropertyId-> ' + JSON.stringify(field[group[nameGroup][y].fields[i].id]))
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup][y].fields[i].id])
                                                            itemPropertyId = field[group[nameGroup][y].fields[i].id].id;
                                                }
                                                break;
                                            case 'fxRate':
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        fxRate = field[group[nameGroup][y].fields[i].id].replace(/,/g, '.');;
                                                }
                                                break;
                                            case 'currencyId':
                                                console.log('id currencyId-> ' + JSON.stringify(group[nameGroup][y].fields[i].id))
                                                console.log('field currencyId-> ' + JSON.stringify(field[group[nameGroup][y].fields[i].id]))
                                                if (group[nameGroup][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup][y].fields[i].where !== null && group[nameGroup][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup][y].fields[i].id])
                                                            currencyId = field[group[nameGroup][y].fields[i].id].id;
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }

                                    if (fxRate && currencyId && entityPropertyId && trxPropId && itemPropertyId && (amount || qty)) {
                                        requestArrayTariff.push({
                                            daysToDue: Number(daysToDue),
                                            fxRate: Number(fxRate.toString().replace(/,/g, '.')),
                                            currencyId: Number(currencyId),
                                            entityPropertyId: Number(entityPropertyId),
                                            trxPropId: Number(trxPropId),
                                            rateOverride: rateOverride,
                                            amount: Number(amount.toString().replace(/,/g, '.')),
                                            qty: Number(qty.toString().replace(/,/g, '.')),
                                            itemPropertyId: Number(itemPropertyId)
                                        })
                                    }
                                }
                            }
                        }
                    }
                    let requestTrxLineTypeId3 = [];

                    let currenciesAmount = [];
                    for (let p = 0; p < requestArrayTariff.length; p++) {
                        currenciesAmount.push({
                            amount: (Number(requestArrayTariff[p].amount) * Number(sign)).toFixed(2),
                            currencyId: requestArrayTariff[p].currencyId,
                            fxRate: requestArrayTariff[p].fxRate
                        })
                    }

                    let validate = false;

                    console.log('index-> ' + index)
                    if (index !== null) {
                        if (requestArrayTariff.length > 0)
                            validate = true;
                    }
                    if (index === null)
                        if (requestArrayTariff.length > 0)//MODIFICACION 12/12
                            validate = true;

                    console.log('requestArrayTariff-> ' + JSON.stringify(requestArrayTariff))
                    console.log('validate test-> ' + JSON.stringify(validate))
                    if (validate) {

                        informationService.tariff(user.data.instance, requestArrayTariff).then((response) => {

                            if (response.data.length === 0) {

                                setTrxLine1(field, currenciesAmount, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, requestTrxLineTypeId3, null, null, setArrayGroupDelete, searchFieldSource, deleteGroup, setValueSearchSource);


                            } //else {

                            for (let b = 0; b < response.data.length; b++) {
                                let existe = false;
                                for (let p = 0; p < currenciesAmount.length; p++) {
                                    if (Number(response.data[b].currencyId) === currenciesAmount[p].currencyId) {
                                        currenciesAmount[p].amount = (Number(currenciesAmount[p].amount) + Number(response.data[b].amount)).toFixed(2)
                                        existe = true;
                                    }
                                }
                                if (existe === false) {
                                    currenciesAmount.push({
                                        amount: Number(response.data[b].amount).toFixed(2),
                                        currency: response.data[b].currencyId,
                                        fxRate: response.data[b].fxRate
                                    })
                                }
                            }

                            let nameGroups = trxLineGroup(group, 3, field);
                            let signoOriginal = 0;
                            console.log('nameGroups-> ' + JSON.stringify(nameGroups))
                            for (let a1 = 0; a1 < group[nameGroups].length; a1++) {
                                for (let i = 0; i < group[nameGroups][0].fields.length; i++) {
                                    if (group[nameGroups][0].fields[i].idFieldTable === 'sign') {
                                        signoOriginal = field[group[nameGroups][0].fields[i].id];
                                    }
                                }
                            }
                            console.log('signo final-> ' + signoOriginal)
                            for (let a1 = 0; a1 < nameGroups.length; a1++) {
                                //let groupTrxLine3Flag = [addElementGroup('trxLine3', false)];
                                let groupTrxLine3Flag = [addElementGroup(nameGroups[a1], false)];

                                for (let i = 0; i < groupTrxLine3Flag[0].fields.length; i++) {
                                    let idField = groupTrxLine3Flag[0].fields[i].id;
                                    switch (groupTrxLine3Flag[0].fields[i].idFieldTable) {
                                        case 'id':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: '',
                                            }), []);
                                            break;
                                        case 'trxId':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: id,
                                            }), []);
                                            break;
                                        case 'isInactive':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: 0,
                                            }), []);
                                            break;
                                        case 'sign':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: signoOriginal,
                                            }), []);

                                            break;
                                        case 'qty':
                                            /*setField(prevState => ({
                                                ...prevState,
                                                [idField]: 1,
                                            }), []);*/
                                            break;
                                        case 'trxLineTypeId':
                                            info.forEach((itemInfo) => {
                                                if (itemInfo.source === groupTrxLine3Flag[0].fields[i].sourceSelect) {
                                                    if (3 === Number(itemInfo.id))
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: {
                                                                id: itemInfo.id,
                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            }
                                                        }), []);
                                                }
                                            })
                                            break;
                                        default:
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: null,
                                            }), []);
                                            break;
                                    }
                                }

                                let crear = response.data.length - 1;

                                for (let b = 0; b < crear; b++) {
                                    let objetoTrxLine3 = addElementGroup(nameGroups[a1], false);
                                    groupTrxLine3Flag.push(objetoTrxLine3);

                                    if (b === crear - 1) {
                                        for (let i = 0; i < objetoTrxLine3.fields.length; i++) {
                                            let idField = objetoTrxLine3.fields[i].id;
                                            switch (objetoTrxLine3.fields[i].idFieldTable) {
                                                case 'id':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: '',
                                                    }), []);
                                                    break;
                                                case 'trxId':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: id,
                                                    }), []);
                                                    break;
                                                case 'isInactive':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: 0,
                                                    }), []);
                                                    break;
                                                case 'sign':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: signoOriginal
                                                    }), []);
                                                    break;
                                                case 'qty':
                                                    /*setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: 1,
                                                    }), []);*/
                                                    break;
                                                case 'trxLineTypeId':
                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === objetoTrxLine3.fields[i].sourceSelect) {
                                                            if (3 === Number(itemInfo.id))
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                        }
                                                    })
                                                    break;
                                                default:
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: null,
                                                    }), []);
                                                    break;
                                            }

                                        }
                                    }
                                }
                                for (let b = 0; b < response.data.length; b++) {
                                    let amount = Number(response.data[b].amount).toFixed(2);
                                    amount = amount.toString().replace(/\./g, ',');

                                    let rateResponse = Number(response.data[b].rate) * 100;
                                    let itemPropertyId = response.data[b].itemPropertyId;

                                    let currecyIdResponse = response.data[b].currencyId;
                                    let fxRateResponse = response.data[b].fxRate;
                                    let existeTrxLine3 = false;
                                    for (let y = 0; y < groupTrxLine3Flag.length; y++) {
                                        for (let i = 0; i < groupTrxLine3Flag[y].fields.length; i++) {
                                            if (groupTrxLine3Flag[y].fields[i].idFieldTable === 'itemPropertyId') {
                                                let idField = groupTrxLine3Flag[y].fields[i].id;
                                                if (field[idField] !== null && field[idField] !== undefined) {
                                                    if (Number(field[idField].id) === Number(itemPropertyId)) {
                                                        existeTrxLine3 = true;
                                                        for (let i = 0; i < groupTrxLine3Flag[y].fields.length; i++) {
                                                            let idField = groupTrxLine3Flag[y].fields[i].id;
                                                            switch (groupTrxLine3Flag[y].fields[i].idFieldTable) {
                                                                case 'entityPropertyId':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: null,
                                                                    }), []);
                                                                    break;
                                                                case 'accountId':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: null,
                                                                    }), []);
                                                                    break;
                                                                case 'id':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: 0,
                                                                    }), []);
                                                                    break;
                                                                case 'sign':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: signoOriginal
                                                                    }), []);
                                                                    break;
                                                                case 'fxRate':
                                                                    if (groupTrxLine3Flag[b].fields[i].type.includes('Number')) {
                                                                        let fxRate = fxRateResponse.toString();
                                                                        let step = 0;
                                                                        let decimalValueFlag = groupTrxLine3Flag[b].fields[i].type.split('ber');
                                                                        if (decimalValueFlag.length > 1) {
                                                                            if (decimalValueFlag[1])
                                                                                step = (decimalValueFlag[1]);
                                                                            let valueSplit = fxRate.split(',');

                                                                            if (valueSplit.length > 1) {
                                                                                if (Number(valueSplit[1].length) < Number(step)) {
                                                                                    let ceros = '';
                                                                                    let dif = Number(step) - Number(valueSplit[1].length);
                                                                                    for (let o = 0; o < dif; o++) {
                                                                                        ceros = ceros + '0';
                                                                                    }
                                                                                    fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                                                } else {
                                                                                    fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                                }
                                                                            } else {
                                                                                if (step > 0) {
                                                                                    let ceros = '';
                                                                                    for (let o = 0; o < step; o++) {
                                                                                        ceros = ceros + '0';
                                                                                    }
                                                                                    fxRate = `${valueSplit[0]},${ceros}`;
                                                                                }
                                                                            }
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: fxRate,
                                                                            }), []);
                                                                        }
                                                                    }
                                                                    break;
                                                                case 'currencyId':

                                                                    info.forEach((itemInfo) => {
                                                                        if (itemInfo.source === groupTrxLine3Flag[y].fields[i].sourceSelect) {
                                                                            if (Number(currecyIdResponse) === Number(itemInfo.id)) {

                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: {
                                                                                        id: itemInfo.id,
                                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                    }
                                                                                }), []);

                                                                                requestTrxLineTypeId3.push({
                                                                                    currencyId: itemInfo.id,
                                                                                    line: y.toString()
                                                                                })
                                                                            }

                                                                        }
                                                                    })
                                                                    break;
                                                                case 'qty':
                                                                    /*setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: 1,
                                                                    }), []);*/
                                                                    break;
                                                                case 'amount':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: amount,
                                                                    }), []);
                                                                    break;
                                                                case 'rate':
                                                                    if (groupTrxLine3Flag[y].fields[i].type.includes('Percentage')) {
                                                                        let rate = rateResponse.toString().replace(/\./g, ',');;
                                                                        let step = 0;
                                                                        let decimalValueFlag = groupTrxLine3Flag[y].fields[i].type.split('age');
                                                                        if (decimalValueFlag.length > 1) {
                                                                            if (decimalValueFlag[1])
                                                                                step = (decimalValueFlag[1]);
                                                                            let valueSplit = rate.split(',');

                                                                            if (valueSplit.length > 1) {
                                                                                if (Number(valueSplit[1].length) < Number(step)) {
                                                                                    let ceros = '';
                                                                                    let dif = Number(step) - Number(valueSplit[1].length);
                                                                                    for (let o = 0; o < dif; o++) {
                                                                                        ceros = ceros + '0';
                                                                                    }
                                                                                    rate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                                                } else {
                                                                                    rate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                                }
                                                                            } else {
                                                                                if (step > 0) {
                                                                                    let ceros = '';
                                                                                    for (let o = 0; o < step; o++) {
                                                                                        ceros = ceros + '0';
                                                                                    }
                                                                                    rate = `${valueSplit[0]},${ceros}`;
                                                                                }
                                                                            }
                                                                            setField(prevState => ({
                                                                                ...prevState,
                                                                                [idField]: rate,
                                                                            }), []);
                                                                        }
                                                                    }
                                                                    break;
                                                                case 'isInactive':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: 0,
                                                                    }), []);
                                                                    break;
                                                                case 'trxId':
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: id,
                                                                    }), []);
                                                                    break;
                                                                case 'trxLineTypeId':
                                                                    info.forEach((itemInfo) => {
                                                                        if (itemInfo.source === groupTrxLine3Flag[y].fields[i].sourceSelect) {
                                                                            if (3 === Number(itemInfo.id))
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: {
                                                                                        id: itemInfo.id,
                                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                    }
                                                                                }), []);
                                                                        }
                                                                    })
                                                                    break;
                                                                case 'itemPropertyId':
                                                                    info.forEach((itemInfo) => {
                                                                        if (itemInfo.source === groupTrxLine3Flag[y].fields[i].sourceSelect) {
                                                                            if (Number(itemPropertyId) === Number(itemInfo.id)) {
                                                                                setField(prevState => ({
                                                                                    ...prevState,
                                                                                    [idField]: {
                                                                                        id: itemInfo.id,
                                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                                    }
                                                                                }), []);

                                                                                requestTrxLineTypeId3.push({
                                                                                    itemPropertyId: itemInfo.id,
                                                                                    line: y.toString()
                                                                                })

                                                                            }
                                                                        }
                                                                    })
                                                                    break;
                                                                default:
                                                                    break;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if (existeTrxLine3 === false) {
                                        for (let i = 0; i < groupTrxLine3Flag[b].fields.length; i++) {
                                            let idField = groupTrxLine3Flag[b].fields[i].id;

                                            switch (groupTrxLine3Flag[b].fields[i].idFieldTable) {
                                                case 'entityPropertyId':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: null,
                                                    }), []);
                                                    break;
                                                case 'accountId':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: null,
                                                    }), []);
                                                    break;
                                                case 'id':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: 0,
                                                    }), []);
                                                    break;
                                                case 'sign':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: signoOriginal
                                                    }), []);
                                                    break;
                                                case 'fxRate':
                                                    if (groupTrxLine3Flag[b].fields[i].type.includes('Number')) {
                                                        let fxRate = fxRateResponse.toString();
                                                        let step = 0;
                                                        let decimalValueFlag = groupTrxLine3Flag[b].fields[i].type.split('ber');
                                                        if (decimalValueFlag.length > 1) {
                                                            if (decimalValueFlag[1])
                                                                step = (decimalValueFlag[1]);
                                                            let valueSplit = fxRate.split(',');

                                                            if (valueSplit.length > 1) {
                                                                if (Number(valueSplit[1].length) < Number(step)) {
                                                                    let ceros = '';
                                                                    let dif = Number(step) - Number(valueSplit[1].length);
                                                                    for (let o = 0; o < dif; o++) {
                                                                        ceros = ceros + '0';
                                                                    }
                                                                    fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                                } else {
                                                                    fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                }
                                                            } else {
                                                                if (step > 0) {
                                                                    let ceros = '';
                                                                    for (let o = 0; o < step; o++) {
                                                                        ceros = ceros + '0';
                                                                    }
                                                                    fxRate = `${valueSplit[0]},${ceros}`;
                                                                }
                                                            }
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: fxRate,
                                                            }), []);
                                                        }
                                                    }
                                                    break;
                                                case 'currencyId':
                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === groupTrxLine3Flag[b].fields[i].sourceSelect) {
                                                            if (Number(currecyIdResponse) === Number(itemInfo.id)) {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                                requestTrxLineTypeId3.push({
                                                                    currencyId: itemInfo.id,
                                                                    line: b.toString()
                                                                })
                                                            }

                                                        }
                                                    })
                                                    break;
                                                case 'qty':
                                                    /*setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: 1,
                                                    }), []);*/
                                                    break;
                                                case 'amount':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: amount,
                                                    }), []);
                                                    break;
                                                case 'rate':
                                                    if (groupTrxLine3Flag[b].fields[i].type.includes('Percentage')) {
                                                        let rate = rateResponse.toString().replace(/\./g, ',');;
                                                        let step = 0;
                                                        let decimalValueFlag = groupTrxLine3Flag[b].fields[i].type.split('age');
                                                        if (decimalValueFlag.length > 1) {
                                                            if (decimalValueFlag[1])
                                                                step = (decimalValueFlag[1]);
                                                            let valueSplit = rate.split(',');

                                                            if (valueSplit.length > 1) {
                                                                if (Number(valueSplit[1].length) < Number(step)) {
                                                                    let ceros = '';
                                                                    let dif = Number(step) - Number(valueSplit[1].length);
                                                                    for (let o = 0; o < dif; o++) {
                                                                        ceros = ceros + '0';
                                                                    }
                                                                    rate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                                } else {
                                                                    rate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                }
                                                            } else {
                                                                if (step > 0) {
                                                                    let ceros = '';
                                                                    for (let o = 0; o < step; o++) {
                                                                        ceros = ceros + '0';
                                                                    }
                                                                    rate = `${valueSplit[0]},${ceros}`;
                                                                }
                                                            }
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: rate,
                                                            }), []);
                                                        }
                                                    }
                                                    break;
                                                case 'isInactive':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: 0,
                                                    }), []);
                                                    break;
                                                case 'trxId':
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: id,
                                                    }), []);
                                                    break;
                                                case 'trxLineTypeId':
                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === groupTrxLine3Flag[b].fields[i].sourceSelect) {
                                                            if (3 === Number(itemInfo.id)) {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                            }

                                                        }
                                                    })
                                                    break;
                                                case 'itemPropertyId':

                                                    info.forEach((itemInfo) => {
                                                        if (itemInfo.source === groupTrxLine3Flag[b].fields[i].sourceSelect) {
                                                            if (Number(itemPropertyId) === Number(itemInfo.id)) {
                                                                setField(prevState => ({
                                                                    ...prevState,
                                                                    [idField]: {
                                                                        id: itemInfo.id,
                                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                    }
                                                                }), []);
                                                                requestTrxLineTypeId3.push({
                                                                    itemPropertyId: itemInfo.id,
                                                                    line: b.toString()
                                                                })
                                                            }
                                                        }
                                                    })
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                    }
                                }

                                //let copyGroup = JSON.parse(JSON.stringify(group.trxLine3));
                                let copyGroup = JSON.parse(JSON.stringify(group[nameGroups[a1]]));
                                setArrayGroupDelete(prevState => ({
                                    ...prevState,
                                    //'trxLine3': [...(prevState.trxLine3 || []), ...copyGroup],
                                    [nameGroups[a1]]: [...(prevState[nameGroups[a1]] || []), ...copyGroup],
                                }));

                                setGroup(prevState => ({
                                    ...prevState,
                                    //trxLine3: groupTrxLine3Flag
                                    [nameGroups[a1]]: groupTrxLine3Flag
                                }));

                                //TRXLINE 4
                                let requestTribute = requestArrayTariff;
                                for (let b = 0; b < response.data.length; b++) {
                                    requestTribute.push({
                                        itemPropertyId: response.data[b].itemPropertyId,
                                        amount: response.data[b].amount,
                                        qty: 1,
                                        entityPropertyId: Number(entityPropertyId),
                                        trxPropId: Number(trxPropId),
                                        rateOverride: rateOverride,
                                        currencyId: response.data[b].currencyId,
                                        fxRate: response.data[b].fxRate,
                                    })
                                }

                                let groupFlag = group;
                                groupFlag[nameGroups[a1]] = groupTrxLine3Flag;

                                setTrxLine4(item, previousValue, requestTribute, currenciesAmount, field, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, requestTrxLineTypeId3, null, deleteGroup, searchFieldSource, setValueSearchSource);
                            }


                            //}


                        }).catch((error) => {
                            console.log('error->' + error);
                        })
                    } else {
                        setTrxLine1(field, null, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, requestTrxLineTypeId3, null, null, setArrayGroupDelete, searchFieldSource, deleteGroup, setValueSearchSource);

                    }
                }
            }

        }

    } catch (error) {
        console.log('error->' + error);
    }
}
const setTrxLine4 = (item, previousValue, requestTributeParameter, currenciesAmount, field, data, group, addElementGroup, setField, info, setGroup, setArrayGroupDelete, id, requestTrxLineTypeId3, index, deleteGroup, searchFieldSource, setValueSearchSource, mode) => {

    try {
        let validate = false;
        if (item) {
            let idField = item.id;
            let currentValue = field[idField];
            if (currentValue !== previousValue[idField]) {
                validate = true;
            }
        }
        if ((validate) || (item === null && previousValue === null)) {

            let nameGroup2 = trxLineGroup(group, 2, field);
            let nameGroup3 = trxLineGroup(group, 3, field);
            let nameGroup4 = trxLineGroup(group, 4, field);
            if (currenciesAmount === null) {
                currenciesAmount = [];
                for (let a1 = 0; a1 < nameGroup2.length; a1++) {
                    //if (group.trxLine2) {
                    if (group[nameGroup2[a1]]) {
                        for (let y = 0; y < group[nameGroup2[a1]].length; y++) {
                            let sign = 1;
                            for (let i = 0; i < group[nameGroup2[a1]][0].fields.length; i++) {
                                if (group[nameGroup2[a1]][0].fields[i].idFieldTable === 'sign') {
                                    sign = field[group[nameGroup2[a1]][0].fields[i].id];
                                }
                            }
                            if (currenciesAmount.length === 0) {

                                let amount = 0;
                                let currencyId;
                                let fxRate = 1;
                                for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                    switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                        case 'amount':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup2[a1]][y].fields[i].id] !== null && field[group[nameGroup2[a1]][y].fields[i].id] !== undefined)
                                                        amount = ((Number(amount) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                            }
                                            break;
                                        case 'currencyId':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                        currencyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                            }
                                            break;
                                        case 'fxRate':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    fxRate = field[group[nameGroup2[a1]][y].fields[i].id];
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                if (currencyId) {
                                    currenciesAmount.push({
                                        currencyId: currencyId,
                                        amount: amount,
                                        fxRate: fxRate
                                    })
                                }
                            } else {
                                let existe = false;
                                let amount = 0;
                                let currencyId;
                                let fxRate = 1;
                                for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                    switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                        case 'amount':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup2[a1]][y].fields[i].id] !== null && field[group[nameGroup2[a1]][y].fields[i].id] !== undefined)
                                                        amount = ((Number(amount) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                            }
                                            break;
                                        case 'currencyId':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                        currencyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                            }
                                            break;
                                        case 'fxRate':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    fxRate = field[group[nameGroup2[a1]][y].fields[i].id];
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                if (currencyId) {
                                    for (let h = 0; h < currenciesAmount.length; h++) {
                                        if (Number(currenciesAmount[h].currencyId) === Number(currencyId)) {
                                            currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                            existe = true;
                                        }
                                    }
                                    if (existe === false) {
                                        currenciesAmount.push({
                                            currencyId: currencyId,
                                            amount: amount,
                                            fxRate: fxRate
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
                for (let a1 = 0; a1 < nameGroup3.length; a1++) {
                    //if (group.trxLine3) {
                    if (group[nameGroup3[a1]]) {
                        for (let y = 0; y < group[nameGroup3[a1]].length; y++) {

                            let sign = 1;
                            for (let i = 0; i < group[nameGroup3[a1]][0].fields.length; i++) {
                                if (group[nameGroup3[a1]][0].fields[i].idFieldTable === 'sign') {
                                    if (field[group[nameGroup3[a1]][0].fields[i].id])
                                        sign = field[group[nameGroup3[a1]][0].fields[i].id];
                                }
                            }

                            let existe = false;
                            let amount = 0;
                            let currencyId;
                            let fxRate = 1;
                            for (let i = 0; i < group[nameGroup3[a1]][y].fields.length; i++) {
                                switch (group[nameGroup3[a1]][y].fields[i].idFieldTable) {
                                    case 'amount':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup3[a1]][y].fields[i].id] !== null && field[group[nameGroup3[a1]][y].fields[i].id] !== undefined) {
                                                    amount = ((Number(amount) + Number(field[group[nameGroup3[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                                }
                                        }
                                        break;
                                    case 'currencyId':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup3[a1]][y].fields[i].id])
                                                    currencyId = field[group[nameGroup3[a1]][y].fields[i].id].id;
                                        }
                                        break;
                                    case 'fxRate':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                fxRate = field[group[nameGroup3[a1]][y].fields[i].id];
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }

                            if (currencyId) {
                                for (let h = 0; h < currenciesAmount.length; h++) {
                                    if (Number(currenciesAmount[h].currencyId) === Number(currencyId)) {
                                        currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                        existe = true;
                                    }
                                }
                                if (existe === false) {
                                    currenciesAmount.push({
                                        currencyId: currencyId,
                                        amount: amount,
                                        fxRate: fxRate
                                    })
                                }
                            }
                        }
                    }
                }

            }
            const user = AuthService.getCurrentUser();

            //TRXLINETYPEID 4
            let requestTrxLineTypeId4 = [];
            let requestTribute = [];
            let validateApi = false;
            if (index === null) {
                validateApi = true;
            }

            if (requestTributeParameter === null) {
                //recalcular
                let entityPropertyId = null;
                let trxPropId = null;
                let daysToDue = 0;

                data.crud.boxes.forEach((itemBoxes) => {
                    itemBoxes.fields.forEach((itemFields) => {
                        let idfield = itemFields.id;
                        if (field[idfield]) {
                            switch (itemFields.idFieldTable) {
                                case 'daysToDue':
                                    daysToDue = field[idfield] ? field[idfield] : 0;
                                    break;
                                case 'entityPropertyId':
                                    entityPropertyId = field[idfield].id;
                                    break;
                                case 'trxPropId':
                                    trxPropId = field[idfield].id;
                                    break;
                                default:
                                    break;
                            }
                        }
                    })
                });

                for (let a1 = 0; a1 < nameGroup2.length; a1++) {
                    //if (group.trxLine2) {
                    if (group[nameGroup2[a1]]) {

                        for (let y = 0; y < group[nameGroup2[a1]].length; y++) {

                            if (requestTribute.length === 0) {
                                let amount = 0;
                                let qty = 0;
                                let itemPropertyId;
                                let fxRate = 1;
                                let currencyId = null;
                                for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                    switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                        case 'amount':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view && field[group[nameGroup2[a1]][y].fields[i].id])
                                                    amount = Number(amount) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'));
                                            }
                                            break;
                                        case 'qty':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view && field[group[nameGroup2[a1]][y].fields[i].id])
                                                    qty = Number(qty) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'));
                                            }
                                            break;
                                        case 'itemPropertyId':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                        itemPropertyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                            }
                                            break;
                                        case 'fxRate':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    fxRate = field[group[nameGroup2[a1]][y].fields[i].id];
                                            }
                                            break;
                                        case 'currencyId':
                                            if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                        currencyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }

                                if (fxRate && currencyId && entityPropertyId && trxPropId && amount && qty && itemPropertyId) {
                                    requestTribute.push({
                                        daysToDue: Number(daysToDue),
                                        fxRate: Number(fxRate.toString().replace(/,/g, '.')),
                                        currencyId: Number(currencyId),
                                        entityPropertyId: Number(entityPropertyId),
                                        trxPropId: Number(trxPropId),
                                        amount: Number(amount.toString().replace(/,/g, '.')),
                                        qty: Number(qty.toString().replace(/,/g, '.')),
                                        itemPropertyId: Number(itemPropertyId)
                                    })
                                }

                            } else {
                                let existe = false;
                                for (let b = 0; b < requestTribute.length; b++) {
                                    let valueItemPropertyId;
                                    let valueCurrencyId;
                                    let valueFxRateId = 1;
                                    for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                        switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                            case 'itemPropertyId':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                            valueItemPropertyId = field[group[nameGroup2[a1]][y].fields[i].id].id
                                                }
                                                break;
                                            case 'fxRate':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        valueFxRateId = field[group[nameGroup2[a1]][y].fields[i].id].replace(/,/g, '.');
                                                }
                                                break;
                                            case 'currencyId':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                            valueCurrencyId = field[group[nameGroup2[a1]][y].fields[i].id].id
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                    if (Number(requestTribute[b].itemPropertyId) === Number(valueItemPropertyId) &&
                                        Number(requestTribute[b].fxRate) === Number(valueFxRateId) &&
                                        Number(requestTribute[b].currencyId) === Number(valueCurrencyId)) {

                                        for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                            let idField = group[nameGroup2[a1]][y].fields[i].id;
                                            switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                                case 'amount':
                                                    if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                        let view = true;
                                                        if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                            view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                        }
                                                        if (view) {
                                                            let importe = Number(field[idField].toString().replace(/,/g, '.'));
                                                            let importeAnterior = Number(requestTribute[b].amount);
                                                            requestTribute[b].amount = Number(importeAnterior) + Number(importe);
                                                        }
                                                    }
                                                    break;
                                                case 'qty':
                                                    if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                        let view = true;
                                                        if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                            view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                        }
                                                        if (view) {
                                                            let cantidad = Number(field[idField].toString().replace(/,/g, '.'));
                                                            let cantidadAnterior = Number(requestTribute[b].qty)
                                                            requestTribute[b].qty = Number(cantidadAnterior) + Number(cantidad);
                                                        }
                                                    }
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }
                                        existe = true;
                                    }
                                }

                                if (existe === false) {

                                    let amount = 0;
                                    let qty = 0;
                                    let itemPropertyId;
                                    let fxRate = 1;
                                    let currencyId = null;
                                    for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                        switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                            case 'amount':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view && field[group[nameGroup2[a1]][y].fields[i].id])
                                                        amount = Number(amount) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'));
                                                }
                                                break;
                                            case 'qty':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view && field[group[nameGroup2[a1]][y].fields[i].id])
                                                        qty = Number(qty) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'));
                                                }
                                                break;
                                            case 'itemPropertyId':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        itemPropertyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                                }
                                                break;
                                            case 'fxRate':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        fxRate = field[group[nameGroup2[a1]][y].fields[i].id];
                                                }
                                                break;
                                            case 'currencyId':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                            currencyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }

                                    if (fxRate && currencyId && entityPropertyId && trxPropId && amount && qty && itemPropertyId) {
                                        requestTribute.push({
                                            daysToDue: Number(daysToDue),
                                            fxRate: Number(fxRate.toString().replace(/,/g, '.')),
                                            currencyId: Number(currencyId),
                                            entityPropertyId: Number(entityPropertyId),
                                            trxPropId: Number(trxPropId),
                                            amount: Number(amount.toString().replace(/,/g, '.')),
                                            qty: Number(qty.toString().replace(/,/g, '.')),
                                            itemPropertyId: Number(itemPropertyId)
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
                for (let a1 = 0; a1 < nameGroup3.length; a1++) {
                    //if (group.trxLine3) {
                    if (group[nameGroup3[a1]]) {
                        for (let y = 0; y < group[nameGroup3[a1]].length; y++) {

                            let amount = 0;
                            let qty = 0;
                            let itemPropertyId;
                            let fxRate = 1;
                            let currencyId = null;
                            for (let i = 0; i < group[nameGroup3[a1]][y].fields.length; i++) {
                                switch (group[nameGroup3[a1]][y].fields[i].idFieldTable) {
                                    case 'itemPropertyId':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup3[a1]][y].fields[i].id])
                                                    itemPropertyId = field[group[nameGroup3[a1]][y].fields[i].id].id;
                                        }
                                        break;
                                    case 'amount':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view && field[group[nameGroup3[a1]][y].fields[i].id])
                                                amount = Number(amount) + Number(field[group[nameGroup3[a1]][y].fields[i].id].toString().replace(/,/g, '.'));
                                        }
                                        break;
                                    case 'qty':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view && field[group[nameGroup3[a1]][y].fields[i].id])
                                                qty = Number(qty) + Number(field[group[nameGroup3[a1]][y].fields[i].id].toString().replace(/,/g, '.'));
                                        }
                                        break;
                                    case 'fxRate':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                fxRate = field[group[nameGroup3[a1]][y].fields[i].id];
                                        }
                                        break;
                                    case 'currencyId':
                                        if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup3[a1]][y].fields[i].id])
                                                    currencyId = field[group[nameGroup3[a1]][y].fields[i].id].id;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }

                            if (fxRate && currencyId && entityPropertyId && trxPropId && amount && itemPropertyId) {
                                requestTribute.push({
                                    daysToDue: Number(daysToDue),
                                    fxRate: Number(fxRate.toString().replace(/,/g, '.')),
                                    currencyId: Number(currencyId),
                                    entityPropertyId: Number(entityPropertyId),
                                    trxPropId: Number(trxPropId),
                                    amount: Number(amount.toString().replace(/,/g, '.')),
                                    qty: Number(qty.toString().replace(/,/g, '.')),
                                    itemPropertyId: Number(itemPropertyId)
                                })
                            }

                            if (index === y) {
                                if (fxRate && currencyId && entityPropertyId && trxPropId && amount >= 0 && itemPropertyId) {
                                    validateApi = true;
                                }
                            }
                        }
                    }
                }

            } else {
                validateApi = true;
                requestTribute = requestTributeParameter;
            }

            if (validateApi) {
                informationService.tribute(user.data.instance, requestTribute).then((response) => {
                    for (let b = 0; b < response.data.length; b++) {
                        let existe = false;
                        for (let p = 0; p < currenciesAmount.length; p++) {
                            if (Number(response.data[b].currencyId) === Number(currenciesAmount[p].currencyId)) {
                                currenciesAmount[p].amount = (Number(currenciesAmount[p].amount) + Number(response.data[b].amount)).toFixed(2)
                                existe = true;
                            }
                        }
                        if (existe === false) {
                            currenciesAmount.push({
                                amount: Number(response.data[b].amount).toFixed(2),
                                currency: response.data[b].currencyId,
                                fxRate: response.data[b].fxRate
                            })
                        }
                    }

                    let signoOriginal = 0;
                    console.log('nameGroups-> ' + JSON.stringify(nameGroup4))
                    for (let a1 = 0; a1 < group[nameGroup4].length; a1++) {
                        for (let i = 0; i < group[nameGroup4][0].fields.length; i++) {
                            if (group[nameGroup4][0].fields[i].idFieldTable === 'sign') {
                                signoOriginal = field[group[nameGroup4][0].fields[i].id];
                            }
                        }
                    }
                    console.log('signo final-> ' + signoOriginal)

                    for (let a1 = 0; a1 < nameGroup4.length; a1++) {
                        //let groupTrxLine4Flag = [addElementGroup('trxLine4', false)];
                        let groupTrxLine4Flag = [addElementGroup(nameGroup4[a1], false)];
                        for (let i = 0; i < groupTrxLine4Flag[0].fields.length; i++) {
                            let idField = groupTrxLine4Flag[0].fields[i].id;
                            switch (groupTrxLine4Flag[0].fields[i].idFieldTable) {
                                case 'id':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: '',
                                    }), []);
                                    break;
                                case 'trxId':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: id,
                                    }), []);
                                    break;
                                case 'isInactive':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: 0,
                                    }), []);
                                    break;
                                case 'sign':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: signoOriginal
                                    }), []);
                                    break;
                                case 'qty':
                                    /*setField(prevState => ({
                                        ...prevState,
                                        [idField]: 1,
                                    }), []);*/
                                    break;
                                case 'trxLineTypeId':
                                    info.forEach((itemInfo) => {
                                        if (itemInfo.source === groupTrxLine4Flag[0].fields[i].sourceSelect) {
                                            if (4 === Number(itemInfo.id))
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    }
                                                }), []);
                                        }
                                    })
                                    break;
                                default:
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: null,
                                    }), []);
                                    break;
                            }
                        }

                        let crear = response.data.length - 1;
                        for (let b = 0; b < crear; b++) {
                            //let objetoTrxLine4 = addElementGroup('trxLine4', false);
                            let objetoTrxLine4 = addElementGroup(nameGroup4[a1], false);
                            groupTrxLine4Flag.push(objetoTrxLine4);

                            if (b === crear - 1) {
                                for (let i = 0; i < objetoTrxLine4.fields.length; i++) {
                                    let idField = objetoTrxLine4.fields[i].id;
                                    switch (objetoTrxLine4.fields[i].idFieldTable) {
                                        case 'id':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: '',
                                            }), []);
                                            break;
                                        case 'trxId':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: id,
                                            }), []);
                                            break;
                                        case 'isInactive':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: 0,
                                            }), []);
                                            break;
                                        case 'sign':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: signoOriginal
                                            }), []);
                                            break;
                                        case 'qty':
                                            /*setField(prevState => ({
                                                ...prevState,
                                                [idField]: 1,
                                            }), []);*/
                                            break;
                                        case 'trxLineTypeId':
                                            info.forEach((itemInfo) => {
                                                if (itemInfo.source === objetoTrxLine4.fields[i].sourceSelect) {
                                                    if (4 === Number(itemInfo.id))
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: {
                                                                id: itemInfo.id,
                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            }
                                                        }), []);
                                                }
                                            })
                                            break;
                                        default:
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: null,
                                            }), []);
                                            break;
                                    }

                                }
                            }
                        }

                        for (let b = 0; b < response.data.length; b++) {
                            let amount = Number(response.data[b].amount).toFixed(2);
                            amount = amount.toString().replace(/\./g, ',');

                            let rateResponse = Number(response.data[b].rate) * 100;
                            let itemPropertyId = response.data[b].itemPropertyId;

                            let currecyIdResponse = response.data[b].currencyId;
                            let fxRateResponse = response.data[b].fxRate;

                            let existeTrxLine4 = false;
                            for (let y = 0; y < groupTrxLine4Flag.length; y++) {
                                for (let i = 0; i < groupTrxLine4Flag[y].fields.length; i++) {
                                    if (groupTrxLine4Flag[y].fields[i].idFieldTable === 'itemPropertyId') {
                                        let idField = groupTrxLine4Flag[y].fields[i].id;
                                        if (field[idField] !== null && field[idField] !== undefined) {
                                            if (Number(field[idField].id) === Number(itemPropertyId)) {
                                                existeTrxLine4 = true;
                                                for (let i = 0; i < groupTrxLine4Flag[y].fields.length; i++) {
                                                    let idField = groupTrxLine4Flag[y].fields[i].id;
                                                    switch (groupTrxLine4Flag[y].fields[i].idFieldTable) {
                                                        case 'entityPropertyId':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: null,
                                                            }), []);
                                                            break;
                                                        case 'accountId':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: null,
                                                            }), []);
                                                            break;
                                                        case 'id':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: 0,
                                                            }), []);
                                                            break;
                                                        case 'sign':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: signoOriginal
                                                            }), []);
                                                            break;
                                                        case 'fxRate':
                                                            if (groupTrxLine4Flag[y].fields[i].type.includes('Number')) {
                                                                let fxRate = fxRateResponse.toString();
                                                                let step = 0;
                                                                let decimalValueFlag = groupTrxLine4Flag[y].fields[i].type.split('ber');
                                                                if (decimalValueFlag.length > 1) {
                                                                    if (decimalValueFlag[1])
                                                                        step = (decimalValueFlag[1]);
                                                                    let valueSplit = fxRate.split(',');

                                                                    if (valueSplit.length > 1) {
                                                                        if (Number(valueSplit[1].length) < Number(step)) {
                                                                            let ceros = '';
                                                                            let dif = Number(step) - Number(valueSplit[1].length);
                                                                            for (let o = 0; o < dif; o++) {
                                                                                ceros = ceros + '0';
                                                                            }
                                                                            fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                                        } else {
                                                                            fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                        }
                                                                    } else {
                                                                        if (step > 0) {
                                                                            let ceros = '';
                                                                            for (let o = 0; o < step; o++) {
                                                                                ceros = ceros + '0';
                                                                            }
                                                                            fxRate = `${valueSplit[0]},${ceros}`;
                                                                        }
                                                                    }
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: fxRate,
                                                                    }), []);
                                                                }
                                                            }
                                                            break;
                                                        case 'currencyId':

                                                            info.forEach((itemInfo) => {
                                                                if (itemInfo.source === groupTrxLine4Flag[y].fields[i].sourceSelect) {
                                                                    if (Number(currecyIdResponse) === Number(itemInfo.id)) {
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);
                                                                        requestTrxLineTypeId4.push({
                                                                            currencyId: itemInfo.id,
                                                                            line: y.toString()
                                                                        })
                                                                    }
                                                                }
                                                            })
                                                            break;
                                                        case 'qty':
                                                            /*setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: 1,
                                                            }), []);*/
                                                            break;
                                                        case 'amount':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: amount,
                                                            }), []);
                                                            break;
                                                        case 'rate':
                                                            if (groupTrxLine4Flag[y].fields[i].type.includes('Percentage')) {
                                                                let rate = rateResponse.toString().replace(/\./g, ',');;
                                                                let step = 0;
                                                                let decimalValueFlag = groupTrxLine4Flag[y].fields[i].type.split('age');
                                                                if (decimalValueFlag.length > 1) {
                                                                    if (decimalValueFlag[1])
                                                                        step = (decimalValueFlag[1]);
                                                                    let valueSplit = rate.split(',');

                                                                    if (valueSplit.length > 1) {
                                                                        if (Number(valueSplit[1].length) < Number(step)) {
                                                                            let ceros = '';
                                                                            let dif = Number(step) - Number(valueSplit[1].length);
                                                                            for (let o = 0; o < dif; o++) {
                                                                                ceros = ceros + '0';
                                                                            }
                                                                            rate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                                        } else {
                                                                            rate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                                        }
                                                                    } else {
                                                                        if (step > 0) {
                                                                            let ceros = '';
                                                                            for (let o = 0; o < step; o++) {
                                                                                ceros = ceros + '0';
                                                                            }
                                                                            rate = `${valueSplit[0]},${ceros}`;
                                                                        }
                                                                    }
                                                                    setField(prevState => ({
                                                                        ...prevState,
                                                                        [idField]: rate,
                                                                    }), []);
                                                                }
                                                            }

                                                            break;
                                                        case 'isInactive':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: 0,
                                                            }), []);
                                                            break;
                                                        case 'trxId':
                                                            setField(prevState => ({
                                                                ...prevState,
                                                                [idField]: id,
                                                            }), []);
                                                            break;
                                                        case 'trxLineTypeId':
                                                            info.forEach((itemInfo) => {
                                                                if (itemInfo.source === groupTrxLine4Flag[y].fields[i].sourceSelect) {
                                                                    if (4 === Number(itemInfo.id))
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);
                                                                }
                                                            })
                                                            break;
                                                        case 'itemPropertyId':
                                                            info.forEach((itemInfo) => {
                                                                //if (itemInfo.source === 'service') {
                                                                if (itemInfo.source === groupTrxLine4Flag[y].fields[i].sourceSelect) {
                                                                    if (Number(itemPropertyId) === Number(itemInfo.id)) {
                                                                        setField(prevState => ({
                                                                            ...prevState,
                                                                            [idField]: {
                                                                                id: itemInfo.id,
                                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                                            }
                                                                        }), []);

                                                                        requestTrxLineTypeId4.push({
                                                                            itemPropertyId: itemInfo.id,
                                                                            line: y.toString()
                                                                        })
                                                                    }
                                                                }
                                                            })
                                                            break;
                                                        default:
                                                            break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            if (existeTrxLine4 === false) {
                                for (let i = 0; i < groupTrxLine4Flag[b].fields.length; i++) {
                                    let idField = groupTrxLine4Flag[b].fields[i].id;

                                    switch (groupTrxLine4Flag[b].fields[i].idFieldTable) {
                                        case 'entityPropertyId':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: null,
                                            }), []);
                                            break;
                                        case 'accountId':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: null,
                                            }), []);
                                            break;
                                        case 'id':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: 0,
                                            }), []);
                                            break;
                                        case 'sign':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: signoOriginal
                                            }), []);
                                            break;
                                        case 'fxRate':
                                            if (groupTrxLine4Flag[b].fields[i].type.includes('Number')) {
                                                let step = 0;
                                                let fxRate = fxRateResponse.toString();
                                                let decimalValueFlag = groupTrxLine4Flag[b].fields[i].type.split('ber');
                                                if (decimalValueFlag.length > 1) {
                                                    if (decimalValueFlag[1])
                                                        step = (decimalValueFlag[1]);
                                                    let valueSplit = fxRate.split(',');

                                                    if (valueSplit.length > 1) {
                                                        if (Number(valueSplit[1].length) < Number(step)) {
                                                            let ceros = '';
                                                            let dif = Number(step) - Number(valueSplit[1].length);
                                                            for (let o = 0; o < dif; o++) {
                                                                ceros = ceros + '0';
                                                            }
                                                            fxRate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                        } else {
                                                            fxRate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                        }
                                                    } else {
                                                        if (step > 0) {
                                                            let ceros = '';
                                                            for (let o = 0; o < step; o++) {
                                                                ceros = ceros + '0';
                                                            }
                                                            fxRate = `${valueSplit[0]},${ceros}`;
                                                        }
                                                    }
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: fxRate,
                                                    }), []);
                                                }
                                            }
                                            break;
                                        case 'currencyId':
                                            info.forEach((itemInfo) => {
                                                if (itemInfo.source === groupTrxLine4Flag[b].fields[i].sourceSelect) {
                                                    if (Number(currecyIdResponse) === Number(itemInfo.id))
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: {
                                                                id: itemInfo.id,
                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            }
                                                        }), []);
                                                }
                                            })
                                            break;
                                        case 'qty':
                                            /*setField(prevState => ({
                                                ...prevState,
                                                [idField]: 1,
                                            }), []);*/
                                            break;
                                        case 'amount':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: amount,
                                            }), []);
                                            break;
                                        case 'rate':
                                            if (groupTrxLine4Flag[b].fields[i].type.includes('Percentage')) {
                                                let rate = rateResponse.toString().replace(/\./g, ',');;
                                                let step = 0;
                                                let decimalValueFlag = groupTrxLine4Flag[b].fields[i].type.split('age');
                                                if (decimalValueFlag.length > 1) {
                                                    if (decimalValueFlag[1])
                                                        step = (decimalValueFlag[1]);
                                                    let valueSplit = rate.split(',');

                                                    if (valueSplit.length > 1) {
                                                        if (Number(valueSplit[1].length) < Number(step)) {
                                                            let ceros = '';
                                                            let dif = Number(step) - Number(valueSplit[1].length);
                                                            for (let o = 0; o < dif; o++) {
                                                                ceros = ceros + '0';
                                                            }
                                                            rate = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                        } else {
                                                            rate = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                        }
                                                    } else {
                                                        if (step > 0) {
                                                            let ceros = '';
                                                            for (let o = 0; o < step; o++) {
                                                                ceros = ceros + '0';
                                                            }
                                                            rate = `${valueSplit[0]},${ceros}`;
                                                        }
                                                    }
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: rate,
                                                    }), []);
                                                }
                                            }
                                            break;
                                        case 'isInactive':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: 0,
                                            }), []);
                                            break;
                                        case 'trxId':
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: id,
                                            }), []);
                                            break;
                                        case 'trxLineTypeId':
                                            info.forEach((itemInfo) => {
                                                if (itemInfo.source === groupTrxLine4Flag[b].fields[i].sourceSelect) {
                                                    if (4 === Number(itemInfo.id))
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: {
                                                                id: itemInfo.id,
                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            }
                                                        }), []);
                                                }
                                            })
                                            break;
                                        case 'itemPropertyId':

                                            info.forEach((itemInfo) => {
                                                //if (itemInfo.source === 'service' || ) {
                                                if (itemInfo.source === groupTrxLine4Flag[b].fields[i].sourceSelect) {
                                                    if (Number(itemPropertyId) === Number(itemInfo.id)) {
                                                        setField(prevState => ({
                                                            ...prevState,
                                                            [idField]: {
                                                                id: itemInfo.id,
                                                                label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                            }
                                                        }), []);
                                                        requestTrxLineTypeId4.push({
                                                            itemPropertyId: itemInfo.id,
                                                            line: b.toString()
                                                        })
                                                    }

                                                }
                                            })
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            }
                        }

                        //let copyGroup = JSON.parse(JSON.stringify(group.trxLine4));
                        let copyGroup = JSON.parse(JSON.stringify(group[nameGroup4[a1]]));

                        setArrayGroupDelete(prevState => ({
                            ...prevState,
                            //'trxLine4': [...(prevState.trxLine4 || []), ...copyGroup],
                            [nameGroup4[a1]]: [...(prevState[nameGroup4[a1]] || []), ...copyGroup],
                        }));

                        setGroup(prevState => ({
                            ...prevState,
                            //trxLine4: groupTrxLine4Flag
                            [nameGroup4[a1]]: groupTrxLine4Flag
                        }));

                        let groupFlag = group;
                        //groupFlag.trxLine4 = groupTrxLine4Flag
                        groupFlag[nameGroup4[a1]] = groupTrxLine4Flag
                        setTrxLine1(field, currenciesAmount, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, requestTrxLineTypeId3, requestTrxLineTypeId4, null, setArrayGroupDelete, searchFieldSource, deleteGroup, setValueSearchSource);
                    }
                }).catch((error) => {
                    console.log('error->' + error);
                })
            } else {
                setTrxLine1(field, currenciesAmount, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, requestTrxLineTypeId3, requestTrxLineTypeId4, null, setArrayGroupDelete, searchFieldSource, deleteGroup, setValueSearchSource);
            }
        }

    } catch (error) {
        console.log(error)
    }

}

const setTrxLine1 = async (field, currenciesAmount, group, setField, info, id, addElementGroup, setGroup, item, data, previousValue, requestTrxLineTypeId3, requestTrxLineTypeId4, requestTrxLineTypeId5, setArrayGroupDelete, searchFieldSource, deleteGroup, setValueSearchSource, mode) => {
    try {
        let validate = false;

        if (item) {
            let idField = item.id;
            let currentValue = field[idField];
            if (currentValue !== previousValue[idField] && (item.idFieldTable === 'currencyId' || item.idFieldTable === 'fxRate' || item.idFieldTable === 'entityBankAccountId' || item.idFieldTable === 'itemPropertyId' || item.idFieldTable === 'amount' || item.idFieldTable === 'qty' || item.idFieldTable === 'price')) {
                validate = true;
            }
        }
        console.log('setTrxLine1')
        console.log('validate-> ' + validate)
        if (validate === true || deleteGroup) {

            let nameGroup1 = trxLineGroup(group, 1, field);
            let nameGroup2 = trxLineGroup(group, 2, field);
            let nameGroup3 = trxLineGroup(group, 3, field);
            let nameGroup4 = trxLineGroup(group, 4, field);
            let nameGroup5 = trxLineGroup(group, 5, field);
            if (currenciesAmount === null || currenciesAmount.length === 0) {
                currenciesAmount = [];
                for (let a1 = 0; a1 < nameGroup2.length; a1++) {
                    //if (group.trxLine2) {
                    if (group[nameGroup2[a1]]) {
                        for (let y = 0; y < group[nameGroup2[a1]].length; y++) {
                            let sign = 1;
                            let isGuarantee = 0;
                            for (let i = 0; i < group[nameGroup2[a1]][0].fields.length; i++) {
                                if (group[nameGroup2[a1]][0].fields[i].idFieldTable === 'sign') {
                                    sign = field[group[nameGroup2[a1]][0].fields[i].id];
                                }
                                if (group[nameGroup2[a1]][0].fields[i].idFieldTable === 'isGuarantee') {
                                    isGuarantee = field[group[nameGroup2[a1]][0].fields[i].id];
                                }
                            }

                            if (Number(isGuarantee) === 0) {

                                if (currenciesAmount.length === 0) {

                                    let amount = 0;
                                    let currencyId;
                                    let fxRate = 1;
                                    for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                        switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                            case 'amount':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view && field[group[nameGroup2[a1]][y].fields[i].id])
                                                        amount = ((Number(amount) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                                }
                                                break;
                                            case 'currencyId':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                            currencyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                                }
                                                break;
                                            case 'fxRate':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        fxRate = field[group[nameGroup2[a1]][y].fields[i].id];
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                    if (currencyId) {
                                        currenciesAmount.push({
                                            currencyId: currencyId,
                                            amount: amount,
                                            fxRate: fxRate
                                        })
                                    }
                                } else {
                                    let existe = false;
                                    let amount = 0;
                                    let currencyId;
                                    let fxRate = 1;
                                    for (let i = 0; i < group[nameGroup2[a1]][y].fields.length; i++) {
                                        switch (group[nameGroup2[a1]][y].fields[i].idFieldTable) {
                                            case 'amount':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view && field[group[nameGroup2[a1]][y].fields[i].id])
                                                        amount = ((Number(amount) + Number(field[group[nameGroup2[a1]][y].fields[i].id].toString().replace(/,/g, '.')))).toFixed(2);
                                                }
                                                break;
                                            case 'currencyId':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        if (field[group[nameGroup2[a1]][y].fields[i].id])
                                                            currencyId = field[group[nameGroup2[a1]][y].fields[i].id].id;
                                                }
                                                break;
                                            case 'fxRate':
                                                if (group[nameGroup2[a1]][y].fields[i].display !== 'hidden') {
                                                    let view = true;
                                                    if (group[nameGroup2[a1]][y].fields[i].where !== null && group[nameGroup2[a1]][y].fields[i].where !== undefined) {
                                                        view = whereFunction(group[nameGroup2[a1]][y].fields[i], field, mode);
                                                    }
                                                    if (view)
                                                        fxRate = field[group[nameGroup2[a1]][y].fields[i].id];
                                                }
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                    if (currencyId) {
                                        for (let h = 0; h < currenciesAmount.length; h++) {
                                            if (Number(currenciesAmount[h].currencyId) === Number(currencyId)) {
                                                currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                                existe = true;
                                            }
                                        }
                                        if (existe === false) {
                                            currenciesAmount.push({
                                                currencyId: currencyId,
                                                amount: amount,
                                                fxRate: fxRate
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                for (let a1 = 0; a1 < nameGroup3.length; a1++) {
                    //if (group.trxLine3) {
                    if (group[nameGroup3[a1]]) {
                        for (let y = 0; y < group[nameGroup3[a1]].length; y++) {
                            let sign = 1;
                            let isGuarantee = 0;
                            for (let i = 0; i < group[nameGroup3[a1]][0].fields.length; i++) {
                                if (group[nameGroup3[a1]][0].fields[i].idFieldTable === 'sign') {
                                    if (field[group[nameGroup3[a1]][0].fields[i].id])
                                        sign = field[group[nameGroup3[a1]][0].fields[i].id];
                                }
                                if (group[nameGroup3[a1]][0].fields[i].idFieldTable === 'isGuarantee') {
                                    isGuarantee = field[group[nameGroup3[a1]][0].fields[i].id];
                                }
                            }

                            if (Number(isGuarantee) === 0) {
                                let existe = false;
                                let amount = 0;
                                let currencyId;
                                let fxRate = 1;
                                for (let i = 0; i < group[nameGroup3[a1]][y].fields.length; i++) {
                                    switch (group[nameGroup3[a1]][y].fields[i].idFieldTable) {
                                        case 'amount':
                                            if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup3[a1]][y].fields[i].id])
                                                        amount = ((Number(amount) + Number(field[group[nameGroup3[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                            }
                                            break;
                                        case 'currencyId':
                                            if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup3[a1]][y].fields[i].id])
                                                        currencyId = field[group[nameGroup3[a1]][y].fields[i].id].id;
                                            }
                                            break;
                                        case 'fxRate':
                                            if (group[nameGroup3[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup3[a1]][y].fields[i].where !== null && group[nameGroup3[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup3[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    fxRate = field[group[nameGroup3[a1]][y].fields[i].id];
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                if (currencyId) {
                                    for (let h = 0; h < currenciesAmount.length; h++) {
                                        if (Number(currenciesAmount[h].currencyId) === Number(currencyId)) {
                                            currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                            existe = true;
                                        }
                                    }
                                    if (existe === false) {
                                        currenciesAmount.push({
                                            currencyId: currencyId,
                                            amount: amount,
                                            fxRate: fxRate
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
                for (let a1 = 0; a1 < nameGroup4.length; a1++) {
                    //if (group.trxLine4) {
                    if (group[nameGroup4[a1]]) {
                        for (let y = 0; y < group[nameGroup4[a1]].length; y++) {
                            let sign = 1;
                            let isGuarantee = 0;
                            for (let i = 0; i < group[nameGroup4[a1]][0].fields.length; i++) {
                                if (group[nameGroup4[a1]][0].fields[i].idFieldTable === 'sign') {
                                    if (field[group[nameGroup4[a1]][0].fields[i].id])
                                        sign = field[group[nameGroup4[a1]][0].fields[i].id];
                                }
                                if (group[nameGroup4[a1]][0].fields[i].idFieldTable === 'isGuarantee') {
                                    isGuarantee = field[group[nameGroup3[a1]][0].fields[i].id];
                                }
                            }
                            if (Number(isGuarantee) === 0) {
                                let existe = false;
                                let amount = 0;
                                let currencyId;
                                let fxRate = 1;
                                for (let i = 0; i < group[nameGroup4[a1]][y].fields.length; i++) {
                                    switch (group[nameGroup4[a1]][y].fields[i].idFieldTable) {
                                        case 'amount':
                                            if (group[nameGroup4[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup4[a1]][y].fields[i].where !== null && group[nameGroup4[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup4[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup4[a1]][y].fields[i].id])
                                                        amount = ((Number(amount) + Number(field[group[nameGroup4[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                            }
                                            break;
                                        case 'currencyId':
                                            if (group[nameGroup4[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup4[a1]][y].fields[i].where !== null && group[nameGroup4[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup4[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    if (field[group[nameGroup4[a1]][y].fields[i].id])
                                                        currencyId = field[group[nameGroup4[a1]][y].fields[i].id].id;
                                            }
                                            break;
                                        case 'fxRate':
                                            if (group[nameGroup4[a1]][y].fields[i].display !== 'hidden') {
                                                let view = true;
                                                if (group[nameGroup4[a1]][y].fields[i].where !== null && group[nameGroup4[a1]][y].fields[i].where !== undefined) {
                                                    view = whereFunction(group[nameGroup4[a1]][y].fields[i], field, mode);
                                                }
                                                if (view)
                                                    fxRate = field[group[nameGroup4[a1]][y].fields[i].id];
                                            }
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                if (currencyId) {
                                    for (let h = 0; h < currenciesAmount.length; h++) {
                                        if (Number(currenciesAmount[h].currencyId) === Number(currencyId)) {
                                            currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                            existe = true;
                                        }
                                    }
                                    if (existe === false) {
                                        currenciesAmount.push({
                                            currencyId: currencyId,
                                            amount: amount,
                                            fxRate: fxRate
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
            }
            //validate agrupacion
            let groupOnlyLine5 = false;
            if (currenciesAmount.length === 0) {
                groupOnlyLine5 = true;
            }
            for (let a1 = 0; a1 < nameGroup5.length; a1++) {
                //if (group.trxLine5) {
                if (group[nameGroup5[a1]]) {
                    for (let y = 0; y < group[nameGroup5[a1]].length; y++) {
                        let sign = 1;
                        let isGuarantee = 0;
                        for (let i = 0; i < group[nameGroup5[a1]][0].fields.length; i++) {
                            if (group[nameGroup5[a1]][0].fields[i].idFieldTable === 'sign') {
                                sign = field[group[nameGroup5[a1]][0].fields[i].id];
                            }
                            if (group[nameGroup5[a1]][0].fields[i].idFieldTable === 'isGuarantee') {
                                isGuarantee = field[group[nameGroup5[a1]][0].fields[i].id];
                            }
                        }
                        if (Number(isGuarantee) === 0) {
                            let existe = false;
                            let amount = 0;
                            let currencyId;
                            let fxRate = 1;
                            let entityBankAccountId = null;
                            let itemPropertyId = null;
                            for (let i = 0; i < group[nameGroup5[a1]][y].fields.length; i++) {
                                switch (group[nameGroup5[a1]][y].fields[i].idFieldTable) {
                                    case 'amount':
                                        if (group[nameGroup5[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup5[a1]][y].fields[i].where !== null && group[nameGroup5[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup5[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup5[a1]][y].fields[i].id])
                                                    amount = ((Number(amount) + Number(field[group[nameGroup5[a1]][y].fields[i].id].toString().replace(/,/g, '.'))) * sign).toFixed(2);
                                        }
                                        break;
                                    case 'currencyId':
                                        if (group[nameGroup5[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup5[a1]][y].fields[i].where !== null && group[nameGroup5[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup5[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup5[a1]][y].fields[i].id])
                                                    currencyId = field[group[nameGroup5[a1]][y].fields[i].id].id;
                                        }
                                        break;
                                    case 'fxRate':
                                        if (group[nameGroup5[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup5[a1]][y].fields[i].where !== null && group[nameGroup5[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup5[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                fxRate = field[group[nameGroup5[a1]][y].fields[i].id];
                                        }
                                        break;
                                    case 'entityBankAccountId':
                                        if (group[nameGroup5[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup5[a1]][y].fields[i].where !== null && group[nameGroup5[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup5[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup5[a1]][y].fields[i].id])
                                                    entityBankAccountId = field[group[nameGroup5[a1]][y].fields[i].id].id;
                                        }
                                        break;
                                    case 'itemPropertyId':
                                        if (group[nameGroup5[a1]][y].fields[i].display !== 'hidden') {
                                            let view = true;
                                            if (group[nameGroup5[a1]][y].fields[i].where !== null && group[nameGroup5[a1]][y].fields[i].where !== undefined) {
                                                view = whereFunction(group[nameGroup5[a1]][y].fields[i], field, mode);
                                            }
                                            if (view)
                                                if (field[group[nameGroup5[a1]][y].fields[i].id])
                                                    itemPropertyId = field[group[nameGroup5[a1]][y].fields[i].id].id;
                                        }
                                        break;
                                    default:
                                        break;
                                }
                            }
                            if (currencyId) {

                                for (let h = 0; h < currenciesAmount.length; h++) {
                                    if (groupOnlyLine5 === true) {
                                        if (Number(currenciesAmount[h].currencyId) === Number(currencyId) &&
                                            Number(currenciesAmount[h].entityBankAccountId) === Number(entityBankAccountId) &&
                                            Number(currenciesAmount[h].itemPropertyId) === Number(itemPropertyId)) {
                                            currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                            existe = true;
                                        }
                                    } else {
                                        if (Number(currenciesAmount[h].currencyId) === Number(currencyId)) {
                                            currenciesAmount[h].amount = (Number(currenciesAmount[h].amount) + Number(amount)).toFixed(2);
                                            existe = true;
                                        }
                                    }
                                }
                                if (existe === false) {
                                    currenciesAmount.push({
                                        currencyId: currencyId,
                                        amount: amount,
                                        fxRate: fxRate,
                                        entityBankAccountId: entityBankAccountId,
                                        itemPropertyId: itemPropertyId
                                    })
                                }
                            }
                        }
                    }
                }
            }

            let currenciesTrxLine1 = [];
            for (let a1 = 0; a1 < nameGroup1.length; a1++) {

                //let groupTrxLine1Flag = [addElementGroup('trxLine1', false)];
                let groupTrxLine1Flag = [addElementGroup(nameGroup1[a1], false)];
                let crear = currenciesAmount.length - 1;

                for (let b = 0; b < crear; b++) {
                    //let objetoTrxLine1 = addElementGroup('trxLine1', false);
                    let objetoTrxLine1 = addElementGroup(nameGroup1[a1], false);
                    groupTrxLine1Flag.push(objetoTrxLine1);
                }

                try {
                    let signo = 1;
                    let entityPropertyId = null;
                    data.crud.boxes.forEach((itemBoxes) => {
                        itemBoxes.fields.forEach((itemFields) => {
                            let idfield = itemFields.id;
                            if (field[idfield]) {
                                if (itemFields.idFieldTable === 'sign') {
                                    signo = Number(field[idfield]) * -1;
                                }
                                if (itemFields.idFieldTable === 'entityPropertyId') {
                                    entityPropertyId = field[idfield];
                                }
                            }
                        })
                    });

                    let fieldLocalRecord = {};
                    for (let y = 0; y < groupTrxLine1Flag.length; y++) {
                        for (let i = 0; i < groupTrxLine1Flag[y].fields.length; i++) {
                            let idField = groupTrxLine1Flag[y].fields[i].id;

                            switch (groupTrxLine1Flag[y].fields[i].idFieldTable) {
                                case 'sign':
                                    let sign = signo;
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: sign,
                                    }), []);
                                    fieldLocalRecord[idField] = sign;
                                    break;
                                case 'fxRate':
                                    try {
                                        let fxRateResponse = currenciesAmount[y].fxRate.toString();
                                        if (groupTrxLine1Flag[y].fields[i].type.includes('Number')) {
                                            let step = 0;
                                            let decimalValueFlag = groupTrxLine1Flag[y].fields[i].type.split('ber');
                                            if (decimalValueFlag.length > 1) {
                                                if (decimalValueFlag[1])
                                                    step = (decimalValueFlag[1]);
                                                let valueSplit = fxRateResponse.split(',');

                                                if (valueSplit.length > 1) {
                                                    if (Number(valueSplit[1].length) < Number(step)) {
                                                        let ceros = '';
                                                        let dif = Number(step) - Number(valueSplit[1].length);
                                                        for (let o = 0; o < dif; o++) {
                                                            ceros = ceros + '0';
                                                        }
                                                        fxRateResponse = `${valueSplit[0]},${valueSplit[1]}${ceros}`;
                                                    } else {
                                                        fxRateResponse = `${valueSplit[0]},${valueSplit[1].slice(0, step)}`;
                                                    }
                                                } else {
                                                    if (step > 0) {
                                                        let ceros = '';
                                                        for (let o = 0; o < step; o++) {
                                                            ceros = ceros + '0';
                                                        }
                                                        fxRateResponse = `${valueSplit[0]},${ceros}`;
                                                    }
                                                }
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: fxRateResponse,
                                                }), []);
                                                fieldLocalRecord[idField] = fxRateResponse;
                                            }
                                        }
                                    } catch (error) {
                                        console.log('error 1-> ' + error)
                                    }

                                    break;
                                case 'currencyId':
                                    try {
                                        let currencyHeader = currenciesAmount[y].currencyId;
                                        info.forEach((itemInfo) => {
                                            if (itemInfo.source === groupTrxLine1Flag[y].fields[i].sourceSelect) {
                                                if (Number(currencyHeader) === Number(itemInfo.id)) {
                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: {
                                                            id: itemInfo.id,
                                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        }
                                                    }), []);
                                                    fieldLocalRecord[idField] = {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    };

                                                    currenciesTrxLine1.push(itemInfo.id);
                                                }
                                            }
                                        })

                                    } catch (error) {

                                    }

                                    break;
                                case 'qty':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: 1,
                                    }), []);
                                    fieldLocalRecord[idField] = 1;
                                    break;
                                case 'amount':
                                    try {
                                        //let amount = Number(currenciesAmount[y].amount) < 0 ? Number(currenciesAmount[y].amount) * -1 : Number(currenciesAmount[y].amount);
                                        if (signo !== null && signo !== undefined) {
                                            let signoFlag = Number(signo) * -1;

                                            let amount = Number(currenciesAmount[y].amount) * Number(signoFlag);
                                            if (amount === undefined || amount === null) {
                                                amount = '0,00';
                                            }
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: amount.toString().replace(/\./g, ',')
                                            }), []);
                                            fieldLocalRecord[idField] = amount.toString().replace(/\./g, ',');
                                        } else {
                                            setField(prevState => ({
                                                ...prevState,
                                                [idField]: '0,00'
                                            }), []);
                                            fieldLocalRecord[idField] = '0,00'

                                        }

                                    } catch (error) {
                                        setField(prevState => ({
                                            ...prevState,
                                            [idField]: '0,00'
                                        }), []);
                                        fieldLocalRecord[idField] = '0,00'
                                    }
                                    break;
                                case 'isInactive':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: 0,
                                    }), []);
                                    fieldLocalRecord[idField] = 0
                                    break;
                                case 'trxId':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: id,
                                    }), []);
                                    fieldLocalRecord[idField] = id
                                    break;
                                case 'trxLineTypeId':
                                    info.forEach((itemInfo) => {
                                        if (itemInfo.source === groupTrxLine1Flag[y].fields[i].sourceSelect) {
                                            if (1 === Number(itemInfo.id)) {
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    }
                                                }), []);
                                                fieldLocalRecord[idField] = {
                                                    id: itemInfo.id,
                                                    label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                }
                                            }
                                        }
                                    })
                                    break;
                                case 'itemPropertyId':
                                    try {
                                        info.forEach((itemInfo) => {
                                            let itemPropertyId = currenciesAmount[y].itemPropertyId;
                                            //if (itemInfo.source === 'payment') {
                                            if (itemInfo.source === groupTrxLine1Flag[y].fields[i].sourceSelect) {
                                                if (Number(itemPropertyId) === Number(itemInfo.id)) {

                                                    setField(prevState => ({
                                                        ...prevState,
                                                        [idField]: {
                                                            id: itemInfo.id,
                                                            label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                        }
                                                    }), []);
                                                    fieldLocalRecord[idField] = {
                                                        id: itemInfo.id,
                                                        label: itemInfo.nameAlt !== undefined ? `${itemInfo.name} ${itemInfo.nameAlt}` : `${itemInfo.name}`,
                                                    }
                                                    if (searchFieldSource !== null)
                                                        searchFieldSource(groupTrxLine1Flag[y].fields[i], itemInfo.id, true, groupTrxLine1Flag);
                                                }

                                            }
                                        })

                                    } catch (error) {

                                    }

                                    break;
                                case 'accountId':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: null
                                    }), []);
                                    fieldLocalRecord[idField] = null
                                    break;
                                case 'entityPropertyId':
                                    let value = entityPropertyId;
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: value
                                    }), []);
                                    fieldLocalRecord[idField] = value

                                    break;
                                case 'isGuarantee':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: '0'
                                    }), []);
                                    fieldLocalRecord[idField] = '0'
                                    break;
                                case 'tradeAccountId':
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: ''
                                    }), []);
                                    let table = groupTrxLine1Flag[y].fields[i].search;
                                    let fieldsRequest = [];

                                    if (groupTrxLine1Flag[y].fields[i].searchSource) {
                                        for (let u = 0; u < groupTrxLine1Flag[y].fields[i].searchSource.length; u++) {

                                            data.crud.boxes.forEach((itemBoxs) => {
                                                itemBoxs.fields.forEach((itemFields) => {
                                                    if (itemFields.group === null) {
                                                        if (itemFields.id === groupTrxLine1Flag[y].fields[i].searchSource[u]) {
                                                            let idFieldTable = itemFields.idFieldTable;
                                                            let fieldFlag = idFieldTable.replace('Id', '');
                                                            if (fieldFlag === table) {
                                                                idFieldTable = 'id';
                                                            }
                                                            if (typeof field[itemFields.id] === 'object') {
                                                                if (field[itemFields.id] !== null) {
                                                                    fieldsRequest.push({
                                                                        id: idFieldTable,
                                                                        value: field[itemFields.id].id
                                                                    })
                                                                }
                                                            } else {
                                                                fieldsRequest.push({
                                                                    id: idFieldTable,
                                                                    value: field[itemFields.id]
                                                                })
                                                            }
                                                        }
                                                    }
                                                })
                                            })
                                        }

                                        let valueSearch = groupTrxLine1Flag[y].fields[i].idFieldTable;
                                        const user = AuthService.getCurrentUser();

                                        const response = await informationService.searchSource(table, user.data.instance, fieldsRequest);

                                        if (response.data.length > 0) {
                                            let idSearch = response.data[0][valueSearch];

                                            if (groupTrxLine1Flag[y].fields[i].type === 'Select') {
                                                var fieldSearchValue = valueSearch.replace('Id', '');
                                                let label = response.data[0][fieldSearchValue];
                                                for (const inf of info) {
                                                    if (inf.source === fieldSearchValue) {
                                                        if (Number(inf.id) === Number(idSearch)) {
                                                            label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                                        }
                                                    }
                                                }
                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: {
                                                        id: idSearch,
                                                        label: label
                                                    }
                                                }), []);
                                                fieldLocalRecord[idField] = {
                                                    id: idSearch,
                                                    label: label
                                                }
                                            }
                                        }
                                    }
                                    break;
                                default:
                                    setField(prevState => ({
                                        ...prevState,
                                        [idField]: ''
                                    }), []);
                                    fieldLocalRecord[idField] = ''

                                    break;
                            }
                        }
                    }

                    for (let y = 0; y < groupTrxLine1Flag.length; y++) {
                        for (let i = 0; i < groupTrxLine1Flag[y].fields.length; i++) {
                            let idField = groupTrxLine1Flag[y].fields[i].id;
                            if (groupTrxLine1Flag[y].fields[i].idFieldTable === 'entityBankAccountId') {


                                let table = groupTrxLine1Flag[y].fields[i].search;
                                let fieldsRequest = [];
                                if (groupTrxLine1Flag[y].fields[i].searchSource) {
                                    for (let u = 0; u < groupTrxLine1Flag[y].fields[i].searchSource.length; u++) {
                                        for (let a1 = 0; a1 < groupTrxLine1Flag[y].fields.length; a1++) {
                                            if (groupTrxLine1Flag[y].fields[a1].id === groupTrxLine1Flag[y].fields[i].searchSource[u]) {
                                                let idFieldTable = groupTrxLine1Flag[y].fields[a1].idFieldTable;
                                                if (typeof fieldLocalRecord[groupTrxLine1Flag[y].fields[i].searchSource[u]] === 'object') {
                                                    if (fieldLocalRecord[groupTrxLine1Flag[y].fields[i].searchSource[u]] !== null) {
                                                        fieldsRequest.push({
                                                            id: idFieldTable,
                                                            value: fieldLocalRecord[groupTrxLine1Flag[y].fields[i].searchSource[u]].id
                                                        })
                                                    } else {
                                                        fieldsRequest.push({
                                                            id: idFieldTable,
                                                            value: null
                                                        })
                                                    }
                                                } else {
                                                    fieldsRequest.push({
                                                        id: idFieldTable,
                                                        value: fieldLocalRecord[groupTrxLine1Flag[y].fields[i].searchSource[u]]
                                                    })
                                                }
                                            }
                                        }
                                    }

                                    let validateRequest = true;
                                    for (let g = 0; g < fieldsRequest.length; g++) {
                                        if (fieldsRequest[g].value === null)
                                            validateRequest = false;
                                    }

                                    if (fieldsRequest.length > 0 && validateRequest) {
                                        const user = AuthService.getCurrentUser();

                                        const response = await informationService.searchSource(table, user.data.instance, fieldsRequest);

                                        if (response.data.length > 0) {
                                            let idSearch = response.data[0].id;

                                            if (groupTrxLine1Flag[y].fields[i].type === 'Select') {
                                                let label = '';
                                                for (const inf of info) {
                                                    if (inf.source === groupTrxLine1Flag[y].fields[i].sourceSelect) {
                                                        if (Number(inf.id) === Number(idSearch)) {
                                                            label = inf.nameAlt !== undefined ? `${inf.name} ${inf.nameAlt}` : `${inf.name}`
                                                        }
                                                    }
                                                }

                                                setField(prevState => ({
                                                    ...prevState,
                                                    [idField]: {
                                                        id: idSearch,
                                                        label: label
                                                    }
                                                }), []);

                                                if (searchFieldSource !== null)
                                                    searchFieldSource(groupTrxLine1Flag[y].fields[i], idSearch, true, groupTrxLine1Flag);
                                            }
                                        }
                                    }
                                }
                            }

                        }
                    }
                } catch (error) {
                    console.log('error adef****' + error)
                }

                //let copyGroup = JSON.parse(JSON.stringify(group.trxLine1));
                let copyGroup = JSON.parse(JSON.stringify(group[nameGroup1[a1]]));
                setArrayGroupDelete(prevState => ({
                    ...prevState,
                    //'trxLine1': [...(prevState.trxLine1 || []), ...copyGroup],
                    [nameGroup1[a1]]: [...(prevState[nameGroup1[a1]] || []), ...copyGroup],
                }));

                setGroup(prevState => ({
                    ...prevState,
                    [nameGroup1[a1]]: groupTrxLine1Flag
                }));

                let groupFlag = group;
                groupFlag[nameGroup1[a1]] = groupTrxLine1Flag;
                setAccountId(item, field, previousValue, data, setField, groupFlag, info, requestTrxLineTypeId3, requestTrxLineTypeId4, requestTrxLineTypeId5, searchFieldSource, currenciesTrxLine1);
            }
            if (nameGroup1.length === 0) {
                setAccountId(item, field, previousValue, data, setField, group, info, requestTrxLineTypeId3, requestTrxLineTypeId4, requestTrxLineTypeId5, searchFieldSource, []);
            }
        }
    } catch (error) {
        console.log('error ****' + error)
    }
}

const trxLineGroup = (group, trxLineTypeId, field) => {
    let nameGroupFlag = [];
    for (let key in group) {
        if (group[key]) {
            let lineType;
            for (let d = 0; d < group[key][0].fields.length; d++) {
                if (group[key][0].fields[d].idFieldTable === 'trxLineTypeId') {
                    if (field[group[key][0].fields[d].id]) {
                        lineType = field[group[key][0].fields[d].id].id
                        if (!lineType) {
                            lineType = group[key][0].fields[d].defaultValue;
                        }
                    } else {
                        lineType = group[key][0].fields[d].defaultValue;
                    }
                }
            }
            let validateNameGroup = false;
            for (let d = 0; d < group[key][0].fields.length; d++) {
                if (group[key][0].fields[d].display !== 'hidden') {
                    validateNameGroup = true;
                }
            }
            if (validateNameGroup && Number(lineType) === Number(trxLineTypeId)) {
                nameGroupFlag.push(key);
            }
        }
    }
    return nameGroupFlag;
}

const whereFunction = (itemField, field, mode) => {

    let next = true;
    let validate;
    for (let i = 0; i < itemField.where.length; i++) {
        if (itemField.where[i].field !== null && itemField.where[i].field !== undefined) {
            for (let y = 0; y < itemField.where[i].field.length; y++) {
                if (next === true) {
                    //aca llega a obtener el ID del FIELD
                    let idField = itemField.where[i].field[y].idField;

                    switch (idField) {
                        case 'mode':
                            validate = false;
                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                                if (itemField.where[i].field[y].operator === 'in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if (mode === idFlag) {
                                        validate = true;
                                    }
                                }
                                if (itemField.where[i].field[y].operator === 'not in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if (mode === idFlag) {
                                        validate = false;
                                        break;
                                    } else {
                                        validate = true;
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }
                            break;
                        case 'role':
                            const user = AuthService.getCurrentUser();
                            validate = false;
                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {
                                if (itemField.where[i].field[y].operator === 'in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if (user.data.roleId === idFlag) {
                                        validate = true;
                                    }
                                }
                                if (itemField.where[i].field[y].operator === 'not in') {
                                    let idFlag = itemField.where[i].field[y].id[d];
                                    if (user.data.roleId === idFlag) {
                                        validate = false;
                                        break;
                                    } else {
                                        validate = true;
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }
                            break;
                        default:
                            validate = false;

                            for (let d = 0; d < itemField.where[i].field[y].id.length; d++) {

                                if (itemField.where[i].field[y].operator === 'in') {
                                    if (typeof field[idField] === 'object') {
                                        if (field[idField]) {
                                            if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                                validate = true;
                                            }
                                        } else {
                                            if (field[idField] === itemField.where[i].field[y].id[d]) {
                                                validate = true;
                                            }
                                        }
                                    } else {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (itemField.where[i].field[y].id[d]) {
                                            idFlag = itemField.where[i].field[y].id[d].toString();
                                        }
                                        if (field[idField]) {
                                            if (field[idField].toString() === idFlag) {
                                                validate = true;
                                            }
                                        } else {
                                            if (field[idField] === (idFlag === "true" ? true : idFlag === "false" ? false : idFlag)) {
                                                validate = true;
                                            }
                                        }
                                    }
                                }

                                if (itemField.where[i].field[y].operator === 'not in') {

                                    if (typeof field[idField] === 'object') {
                                        if (field[idField]) {
                                            if (Number(field[idField].id) === Number(itemField.where[i].field[y].id[d])) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        }
                                        else {
                                            if (field[idField] === itemField.where[i].field[y].id[d]) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        }
                                    } else {
                                        let idFlag = itemField.where[i].field[y].id[d];
                                        if (itemField.where[i].field[y].id[d]) {
                                            idFlag = itemField.where[i].field[y].id[d].toString();
                                        }
                                        if (field[idField]) {
                                            if (field[idField].toString() === idFlag) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        } else {
                                            if (field[idField] === idFlag) {
                                                validate = false;
                                                break;
                                            } else {
                                                validate = true;
                                            }
                                        }
                                    }
                                }
                            }
                            if (validate === false) {
                                next = false;
                            }

                            break;
                    }
                }
            }
        }
    }
    return validate;
}

const trxLine = {
    setTrxLine1,
    setTrxLine3,
    setTrxLine4
}

export default trxLine;